module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Light.9ff12f6.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-Light.ttf
// module id = S05E
// module chunks = 3